import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import * as QRCode from 'qrcode';
import { saveAs } from 'file-saver';
import JSZip from 'jszip';

import * as pdfMake from 'pdfmake/build/pdfmake';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {

  // ======================================================
  //                    PAGE STATES
  // ======================================================

  Isloginpage: boolean = false;

  Isregistered: boolean = false;

  IsSpenner: boolean = false;

  showSuccessPopup: boolean = false;

  isqrcode: boolean = false;

  isqrcodeispass: boolean = false;

  Mainapage: boolean = true;


  // ======================================================
  //                    PRODUCT DATA
  // ======================================================

  ppcode: string = '';

  QRPass: string = '';

  today: Date = new Date();

  message: string = '';


  // ======================================================
  //                    QR GENERATION
  // ======================================================

  productCodesText: string = '';

  qrData: {
    code: string;
    dataUrl: string;
  }[] = [];


  // ======================================================
  //                    QR URL
  // ======================================================

  URLBase: string =
    'https://knowyouseed.in/?productCode=';

  baseUrl: string =
    'https://knowyouseed.in/?productCode=';


  // ======================================================
  //                    BACKEND URL
  // ======================================================

  API_BASE_URL: string =
    'https://backend-7u1x.onrender.com';


  // ======================================================
  //                    FORM
  // ======================================================

  orderForm: FormGroup;


  // ======================================================
  //                    CONSTRUCTOR
  // ======================================================

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private route: ActivatedRoute
  ) {

    this.orderForm = this.fb.group({

      productCode: [
        '',
        Validators.required
      ],

      customerName: [
        '',
        Validators.required
      ],

      email: [
        '',
        [
          Validators.required,
          Validators.email
        ]
      ],

      phone: [
        '',
        [
          Validators.required,
          Validators.pattern(/^[0-9]{10}$/)
        ]
      ],

      agree: [
        true,
        Validators.requiredTrue
      ]

    });

    this.baseUrl = this.URLBase;

  }


  // ======================================================
  //                    QR LOGIN
  // ======================================================

  QrLogin() {

    if (this.QRPass === 'go online') {

      this.isqrcodeispass = true;

    } else {

      this.isqrcodeispass = false;

    }

  }


  // ======================================================
  //                    INITIALIZATION
  // ======================================================

  ngOnInit() {

    this.route.queryParams.subscribe(params => {

      const code = params['productCode'];


      // --------------------------------------------------
      // NO PRODUCT CODE
      // --------------------------------------------------

      if (!code) {

        this.Mainapage = true;

        this.Isregistered = false;

        this.Isloginpage = false;

        this.isqrcode = false;

        return;

      }


      console.log(
        '🔍 Product Code:',
        code
      );


      // --------------------------------------------------
      // SET PRODUCT CODE
      // --------------------------------------------------

      this.orderForm.patchValue({

        productCode: code

      });

      this.ppcode = code;


      // --------------------------------------------------
      // QR GENERATOR PAGE
      // --------------------------------------------------

      if (this.ppcode === 'getmyqr') {

        this.isqrcode = true;

        this.isqrcodeispass = false;

        this.Mainapage = false;

        this.Isregistered = false;

        this.Isloginpage = false;

        this.showSuccessPopup = false;

        return;

      }


      // --------------------------------------------------
      // VERIFY PRODUCT
      // --------------------------------------------------

      this.checkProductCode(
        this.ppcode
      )
        .then(data => {

          console.log(
            '🔍 Backend verification result:',
            data
          );


          // ==============================================
          // INVALID QR
          // ==============================================

          if (!data) {

            console.log(
              '❌ Invalid QR Code'
            );

            this.Mainapage = false;

            this.Isregistered = false;

            this.Isloginpage = false;

            this.showSuccessPopup = false;

            this.isqrcode = false;

            alert(
              'Invalid QR Code'
            );

            return;

          }


          // ==============================================
          // ALREADY REGISTERED
          // ==============================================

          if (
            data.isRegistered === true
          ) {

            console.log(
              '⚠️ Product already registered'
            );

            this.Isregistered = true;

            this.Mainapage = false;

            this.Isloginpage = false;

            this.IsSpenner = false;

            this.showSuccessPopup = false;

            this.isqrcode = false;

            return;

          }


          // ==============================================
          // GENUINE + UNUSED
          // ==============================================

          console.log(
            '✅ Genuine product - available for registration'
          );


          this.Isregistered = false;

          this.Mainapage = true;

          this.Isloginpage = false;

          this.IsSpenner = false;

          this.showSuccessPopup = false;

          this.isqrcode = false;


          // ------------------------------------------------
          // PRODUCT CODE
          // ------------------------------------------------

          this.orderForm.patchValue({

            productCode:
              data.serialNumber ||
              this.ppcode

          });

          this.ppcode =
            data.serialNumber ||
            this.ppcode;

        });

    });

  }


  // ======================================================
  //                    VERIFY PRODUCT
  // ======================================================

  checkProductCode(
    productCode: string
  ): Promise<any> {

    return new Promise((resolve) => {

      if (!productCode) {

        console.error(
          '❌ Product code is empty'
        );

        resolve(null);

        return;

      }


      const url =
        `${this.API_BASE_URL}/verify/${encodeURIComponent(productCode)}`;


      console.log(
        '🌐 Verification API:',
        url
      );


      this.http
        .get<any>(url)
        .subscribe({

          next: response => {

            console.log(
              '✅ Verification response:',
              response
            );


            if (
              response &&
              response.success === true &&
              response.valid === true
            ) {

              resolve(
                response.data
              );

            } else {

              resolve(null);

            }

          },


          error: error => {

            console.error(
              '❌ Verification error:',
              error
            );

            resolve(null);

          }

        });

    });

  }


  // ======================================================
  //                    MANUAL CHECK
  // ======================================================

  ispresendt() {

    this.checkProductCode(
      this.ppcode
    )
      .then(data => {

        if (data) {

          console.log(
            '✅ Product:',
            data
          );

        } else {

          console.log(
            '❌ Product not found'
          );

        }

      });

  }


  // ======================================================
  //                    SHOW LOGIN
  // ======================================================

  ShowLogin() {

    this.Isloginpage = true;

    this.showSuccessPopup = false;

    this.Mainapage = false;

    this.Isregistered = false;

    this.IsSpenner = false;

    this.isqrcode = false;

  }


  // ======================================================
  //                    REGISTER PRODUCT
  // ======================================================

  submitOrder() {

    // --------------------------------------------------
    // VALIDATE FORM
    // --------------------------------------------------

    if (!this.orderForm.valid) {

      this.orderForm.markAllAsTouched();

      alert(
        'Please fill all required fields.'
      );

      return;

    }


    // --------------------------------------------------
    // SPINNER
    // --------------------------------------------------

    this.IsSpenner = true;


    // --------------------------------------------------
    // REGISTRATION DATA
    // --------------------------------------------------

    const registrationData = {

      serialNumber:
        this.orderForm.value.productCode,

      customerName:
        this.orderForm.value.customerName,

      email:
        this.orderForm.value.email,

      phone:
        this.orderForm.value.phone

    };


    console.log(
      '📤 Registration request:',
      registrationData
    );


    // --------------------------------------------------
    // REGISTER PRODUCT
    // --------------------------------------------------

    this.http
      .post<any>(
        `${this.API_BASE_URL}/register`,
        registrationData
      )
      .subscribe({

        // ==============================================
        // SUCCESS
        // ==============================================

        next: response => {

          console.log(
            '✅ Registration successful:',
            response
          );


          this.IsSpenner = false;


          // ------------------------------------------------
          // SHOW SUCCESS POPUP
          // ------------------------------------------------

          this.showSuccessPopup = true;

          this.Mainapage = false;

          this.Isregistered = false;

          this.Isloginpage = false;

          this.isqrcode = false;


          // ------------------------------------------------
          // SEND EMAIL
          // ------------------------------------------------

          this.sendEmail1();


          // ------------------------------------------------
          // SEND SMS
          // ------------------------------------------------
          //
          // IMPORTANT:
          //
          // NO MOBILE NUMBER IS HARDCODED.
          //
          // The phone number entered by the customer
          // is passed to the backend.
          //

          this.sendSMS(
            this.orderForm.value.phone
          );

        },


        // ==============================================
        // ERROR
        // ==============================================

        error: error => {

          console.error(
            '❌ Registration failed:',
            error
          );


          this.IsSpenner = false;

          this.showSuccessPopup = false;


          // ============================================
          // ALREADY REGISTERED
          // ============================================

          if (
            error.status === 409
          ) {

            this.Isregistered = true;

            this.Mainapage = false;

            alert(
              'This QR Code is already registered.'
            );

            return;

          }


          // ============================================
          // INVALID QR
          // ============================================

          if (
            error.status === 404
          ) {

            this.Isregistered = false;

            this.Mainapage = false;

            alert(
              'Invalid QR Code.'
            );

            return;

          }


          // ============================================
          // OTHER ERROR
          // ============================================

          alert(

            error.error?.message ||
            'Registration failed. Please try again.'

          );

        }

      });

  }


  // ======================================================
  //                    SEND EMAIL
  // ======================================================

  sendEmail1() {

    const emailData = {

      to:
        this.orderForm.value.email,

      subject:
        'AD - KYSEED',

      html:
        `
        <p>Congratulations</p>

        <p>
          This is an Original Known-You Seeds Product.
          <br>

          For more Products Info visit

          <a href="http://knownyou.co.in">
            http://knownyou.co.in
          </a>

        </p>
        `

    };


    this.http
      .post(
        'https://bd-1-6wc0.onrender.com/send-email',
        emailData
      )
      .subscribe({

        next: response => {

          console.log(
            '✅ Email sent successfully:',
            response
          );

        },

        error: error => {

          console.error(
            '❌ Email sending failed:',
            error
          );

        }

      });

  }


  // ======================================================
  //                    SEND SMS
  // ======================================================
  //
  // IMPORTANT:
  //
  // Mobile number is NOT hardcoded here.
  //
  // The number comes from:
  //
  // orderForm.phone
  //
  // Then Angular sends:
  //
  // {
  //    to: "+91XXXXXXXXXX"
  // }
  //
  // to:
  //
  // POST https://backend-7u1x.onrender.com/send-sms
  //
  // Backend handles Twilio.
  //
  // ======================================================

  sendSMS(phone: string) {

    // --------------------------------------------------
    // VALIDATE PHONE
    // --------------------------------------------------

    if (!phone) {

      console.error(
        '❌ Phone number is missing'
      );

      return;

    }


    // --------------------------------------------------
    // NORMALIZE PHONE NUMBER
    // --------------------------------------------------

    const cleanPhone =
      phone
        .toString()
        .replace(/\D/g, '');


    if (
      cleanPhone.length !== 10
    ) {

      console.error(
        '❌ Invalid phone number:',
        phone
      );

      return;

    }


    // --------------------------------------------------
    // CREATE INTERNATIONAL NUMBER
    // --------------------------------------------------

    const phoneNumber =
      '+91' + cleanPhone;


    // --------------------------------------------------
    // REQUEST PAYLOAD
    // --------------------------------------------------

    const payload = {

      to:
        phoneNumber

    };


    console.log(
      '📤 Sending SMS request:',
      payload
    );


    // --------------------------------------------------
    // CALL BACKEND
    // --------------------------------------------------

    this.http
      .post<any>(
        `${this.API_BASE_URL}/send-sms`,
        payload
      )
      .subscribe({

        // ==============================================
        // SUCCESS
        // ==============================================

        next: response => {

          console.log(
            '✅ SMS sent successfully:',
            response
          );


          if (
            response &&
            response.success === true
          ) {

            console.log(
              '📱 SMS delivered/requested successfully.'
            );

          }

        },


        // ==============================================
        // ERROR
        // ==============================================

        error: error => {

          console.error(
            '❌ SMS sending failed:',
            error
          );


          console.error(
            '❌ Backend SMS response:',
            error.error
          );

        }

      });

  }


  // ======================================================
  //                    GENERATE QR CODES
  // ======================================================

  generateQRCodes() {

    this.baseUrl =
      this.URLBase;


    const codes =
      this.productCodesText
        .split(/[\n,]+/)
        .map(c => c.trim())
        .filter(c => c);


    this.qrData = [];


    const promises =
      codes.map(code => {

        const url =
          this.baseUrl + code;


        return QRCode.toDataURL(

          url,

          {

            margin: 0,

            width: 600,

            errorCorrectionLevel: 'H'

          }

        )
          .then(dataUrl => {

            this.qrData.push({

              code,

              dataUrl

            });

          });

      });


    return Promise.all(
      promises
    );

  }


  // ======================================================
  //                    DOWNLOAD SINGLE QR
  // ======================================================

  downloadQRCode(
    dataUrl: string,
    code: string
  ) {

    const link =
      document.createElement('a');


    link.href =
      dataUrl;


    link.download =
      `${code}.png`;


    link.click();

  }


  // ======================================================
  //                    DOWNLOAD ALL QR AS ZIP
  // ======================================================

  downloadAllAsZip() {

    if (!this.qrData.length) {

      alert(
        'No QR codes to download!'
      );

      return;

    }


    const zip =
      new JSZip();


    const promises =
      this.qrData.map(qr =>

        this.dataURLtoBlob(
          qr.dataUrl
        )
          .then(blob => {

            zip.file(

              `${qr.code}.png`,

              blob

            );

          })

      );


    return Promise.all(
      promises
    )
      .then(() => {

        return zip
          .generateAsync({

            type: 'blob'

          })
          .then(content => {

            saveAs(

              content,

              'qr_codes.zip'

            );

          });

      });

  }


  // ======================================================
  //                    GENERATE CARD WITH QR
  // ======================================================

  generateCardWithQR(
    qrDataUrl: string,
    code: string
  ): Promise<Blob> {

    return new Promise(
      resolve => {

        const canvas =
          document.createElement('canvas');


        const ctx =
          canvas.getContext('2d')!;


        const bgImg =
          new Image();


        const qrImg =
          new Image();


        bgImg.src =
          'assets/Qrtemp.png';


        qrImg.src =
          qrDataUrl;


        bgImg.onload = () => {

          canvas.width =
            bgImg.width;


          canvas.height =
            bgImg.height;


          ctx.drawImage(

            bgImg,

            0,

            0

          );


          qrImg.onload = () => {

            const qrX =
              120;


            const qrY =
              380;


            const qrSize =
              360;


            ctx.drawImage(

              qrImg,

              qrX,

              qrY,

              qrSize,

              qrSize

            );


            canvas.toBlob(

              blob => {

                resolve(
                  blob!
                );

              },

              'image/png'

            );

          };

        };

      }
    );

  }


  // ======================================================
  //                    DOWNLOAD CARD ZIP
  // ======================================================

  downloadAllAsZip1() {

    if (!this.qrData.length) {

      alert(
        'No QR codes to download!'
      );

      return;

    }


    const zip =
      new JSZip();


    const promises =
      this.qrData.map(qr =>

        this.generateCardWithQR(

          qr.dataUrl,

          qr.code

        )
          .then(blob => {

            zip.file(

              `${qr.code}.png`,

              blob

            );

          })

      );


    Promise.all(
      promises
    )
      .then(() => {

        zip
          .generateAsync({

            type: 'blob'

          })
          .then(content => {

            saveAs(

              content,

              'qr_cards.zip'

            );

          });

      });

  }


  // ======================================================
  //                    DATA URL TO BLOB
  // ======================================================

  private dataURLtoBlob(
    dataUrl: string
  ): Promise<Blob> {

    return fetch(
      dataUrl
    )
      .then(res =>
        res.blob()
      );

  }


  // ======================================================
  //                    DOWNLOAD CARD ZIP 2
  // ======================================================

  downloadAllAsZip12() {

    if (
      !this.qrData ||
      !this.qrData.length
    ) {

      alert(
        'No QR codes to download!'
      );

      return;

    }


    const zip =
      new JSZip();


    const promises =
      this.qrData.map(qr =>

        this.generateCardWithQR1(

          qr.dataUrl

        )
          .then(blob => {

            zip.file(

              `${qr.code}.png`,

              blob

            );

          })

      );


    Promise.all(
      promises
    )
      .then(() => {

        zip
          .generateAsync({

            type: 'blob'

          })
          .then(content => {

            saveAs(

              content,

              'qr_cards.zip'

            );

          });

      });

  }


  // ======================================================
  //                    GENERATE CARD VERSION 2
  // ======================================================

  generateCardWithQR1(
    qrDataUrl: string
  ): Promise<Blob> {

    return new Promise(
      resolve => {

        const canvas =
          document.createElement('canvas');


        const ctx =
          canvas.getContext('2d')!;


        const bgImg =
          new Image();


        const qrImg =
          new Image();


        bgImg.src =
          'assets/Qrtemp.png';


        qrImg.src =
          qrDataUrl;


        bgImg.onload = () => {

          canvas.width =
            bgImg.width;


          canvas.height =
            bgImg.height;


          ctx.drawImage(

            bgImg,

            0,

            0

          );


          qrImg.onload = () => {

            const qrSize =
              530;


            const qrX =
              242;


            const qrY =
              520;


            const padding =
              35;


            const radius =
              20;


            // ------------------------------------------
            // WHITE BACKGROUND
            // ------------------------------------------

            ctx.fillStyle =
              '#ffffff';


            ctx.beginPath();


            ctx.moveTo(

              qrX -
              padding +
              radius,

              qrY -
              padding

            );


            ctx.lineTo(

              qrX +
              qrSize +
              padding -
              radius,

              qrY -
              padding

            );


            ctx.quadraticCurveTo(

              qrX +
              qrSize +
              padding,

              qrY -
              padding,

              qrX +
              qrSize +
              padding,

              qrY -
              padding +
              radius

            );


            ctx.lineTo(

              qrX +
              qrSize +
              padding,

              qrY +
              qrSize +
              padding -
              radius

            );


            ctx.quadraticCurveTo(

              qrX +
              qrSize +
              padding,

              qrY +
              qrSize +
              padding,

              qrX +
              qrSize +
              padding -
              radius,

              qrY +
              qrSize +
              padding

            );


            ctx.lineTo(

              qrX -
              padding +
              radius,

              qrY +
              qrSize +
              padding

            );


            ctx.quadraticCurveTo(

              qrX -
              padding,

              qrY +
              qrSize +
              padding,

              qrX -
              padding,

              qrY +
              qrSize +
              padding -
              radius

            );


            ctx.lineTo(

              qrX -
              padding,

              qrY -
              padding +
              radius

            );


            ctx.quadraticCurveTo(

              qrX -
              padding,

              qrY -
              padding,

              qrX -
              padding +
              radius,

              qrY -
              padding

            );


            ctx.closePath();


            ctx.fill();


            // ------------------------------------------
            // DRAW QR
            // ------------------------------------------

            ctx.drawImage(

              qrImg,

              qrX,

              qrY,

              qrSize,

              qrSize

            );


            // ------------------------------------------
            // EXPORT
            // ------------------------------------------

            canvas.toBlob(

              blob => {

                resolve(
                  blob!
                );

              },

              'image/png'

            );

          };

        };

      }
    );

  }


  // ======================================================
  //                    DOWNLOAD PDF
  // ======================================================

  downloadPDF(
    allInOnePage: boolean,
    codesPerRow: number = 3
  ) {

    if (!this.qrData.length) {

      alert(
        'No QR codes!'

      );

      return;

    }


    const content: any[] = [];

    let row: any[] = [];


    // ====================================================
    // ALL QR ON PAGE
    // ====================================================

    if (allInOnePage) {

      this.qrData.forEach(

        (qr, index) => {

          row.push({

            stack: [

              {

                image:
                  qr.dataUrl,

                width:
                  100,

                margin:
                  [0, 0, 0, 5]

              },

              {

                text:
                  qr.code,

                alignment:
                  'center',

                fontSize:
                  10

              }

            ],

            margin:
              [5, 5, 5, 5]

          });


          if (

            (index + 1) %
              codesPerRow === 0 ||

            index ===
              this.qrData.length - 1

          ) {

            content.push({

              columns:
                row

            });


            row = [];

          }

        }

      );

    }


    // ====================================================
    // ONE QR PER PAGE
    // ====================================================

    else {

      this.qrData.forEach(

        (qr, index) => {

          content.push({

            image:
              qr.dataUrl,

            width:
              150,

            margin:
              [0, 20, 0, 10]

          });


          content.push({

            text:
              qr.code,

            margin:
              [0, 0, 0, 20]

          });


          if (

            index <
            this.qrData.length - 1

          ) {

            content.push({

              text:
                '',

              pageBreak:
                'after'

            });

          }

        }

      );

    }


    // ====================================================
    // CREATE PDF
    // ====================================================

    pdfMake
      .createPdf({

        content

      })
      .download(

        'qr_codes.pdf'

      );

  }


  // ======================================================
  //                    SUCCESS LOGIN
  // ======================================================

  succeelogin() {

    this.Isloginpage = true;

    this.showSuccessPopup = false;

    this.Mainapage = false;

    this.Isregistered = false;

    this.IsSpenner = false;

    this.isqrcode = false;

  }

}